/**
 * Default/fallback preview for unknown target types
 *
 * @module pages/tasks/components/previews/DefaultTargetPreview
 */

import type { TargetPreviewProps } from '../../types';

export function DefaultTargetPreview({ task }: TargetPreviewProps) {
  return (
    <div className="flex items-center gap-3 p-2 bg-surface-2/50 rounded border border-border/30">
      <div className="w-12 h-12 bg-surface-2 rounded flex items-center justify-center text-muted">
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs text-muted capitalize">{task.targetType.replace(/_/g, ' ')}</div>
        {task.description && (
          <div className="text-sm text-foreground truncate">{task.description}</div>
        )}
      </div>
    </div>
  );
}
